export const SEARCH_AGAIN_BUTTON = "Search again";
export const GO_BACK_BUTTON = "Go back";
export const AVAILABILITY_ERROR_TITLE =
  "Uh oh! We were unable to process your search request.";
export const AVAILABILITY_ERROR_SUBTITLE = "Something went wrong.";
